var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useIntl } from 'react-intl';
import { messages } from './messages';
import { TopicNavContainer } from './TopicNavContainer';
import { TopicNavItem } from './TopicNavItem';
import { TopicNavSection } from './TopicNavSection';
var renderItems = function (items) {
    return items.map(function (item) { return React.createElement(TopicNavItem, __assign({ key: item.href }, item)); });
};
export function TopicNav(_a) {
    var topics = _a.topics, products = _a.products, onProductsHeadingClick = _a.onProductsHeadingClick;
    var intl = useIntl();
    return (React.createElement(TopicNavContainer, null,
        React.createElement(TopicNavSection, { heading: intl.formatMessage(messages.seeAllTopics), href: "/shop" }, renderItems(topics)),
        React.createElement(TopicNavSection, { heading: intl.formatMessage(messages.seeAllProducts), onHeadingClick: onProductsHeadingClick }, renderItems(products))));
}
